import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { UserId } from 'src/app/models/User';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  userList: UserId[] = [];

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService.getUsers().subscribe((users) => {
      this.userList = users;
    });
  }
}
